import { assignHelp } from './help';
import { ErrorImporting, IMarkdownParser } from './types';
import { getRemarkable } from './getRemarkable';
import { MarkdownBuilder } from './builder/MarkdownBuilder';

/**
 * Toma una cadena de markdown y la convierte a html, incluyendo estilos por
 * defecto
 */
export const parseMarkdown: IMarkdownParser = async (options) => {
  const markdownLibrary = await getRemarkable(options.extensions);

  const css =
    (await import('./styles')).markdownParserStyles ?? new ErrorImporting();
  if (css instanceof ErrorImporting)
    throw new Error('Could not import css, cannot continue');

  const html =
    options.htmlTemplate ??
    (await import('./html')).markdownHtml ??
    new ErrorImporting();
  if (html instanceof ErrorImporting)
    throw new Error('Could not import html, cannot continue');

  const markdownString = options.content;

  const markdownParser = markdownLibrary.render.bind(markdownLibrary);
  let htmlString = markdownParser(markdownString);

  if (options.tableOfContentsTitle) {
    const b = new MarkdownBuilder();
    htmlString = b.addTableOfContents(options.tableOfContentsTitle, htmlString);
  }

  const rendered = html(
    options.title,
    css(options.additionalStyles, options.extensions),
    `${options?.additionalBodyContent?.before ?? ''}${htmlString}${options?.additionalBodyContent?.after ?? ''}`,
  );

  return rendered;
};

assignHelp(parseMarkdown);
